import styles from '@styles/SearchBar.module.css'
import PropTypes from 'prop-types'

const SearchBar = ({ searchTerm, setSearchTerm, searchFilter, setSearchFilter }) => {
  return (
    <div className={styles.searchContainer}>
      <input
        type='text'
        placeholder='Buscar...'
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className={styles.searchInput}
      />
      <select
        value={searchFilter}
        onChange={(e) => setSearchFilter(e.target.value)}
        className={styles.searchSelect}
      >
        <option value='id'>ID</option>
        <option value='brand'>Marca</option>
        <option value='category'>Categoría</option>
        <option value='reference'>Referencia</option>
        <option value='price'>Precio</option>
      </select>
    </div>
  )
}

SearchBar.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  setSearchTerm: PropTypes.func.isRequired,
  searchFilter: PropTypes.string.isRequired,
  setSearchFilter: PropTypes.func.isRequired,
}

export default SearchBar
